import React from 'react'
import {Link} from 'react-router-dom'
import {
  Paper
} from "@material-ui/core";

const UnfulfilledOrders = () => {
  return (
    <div><Paper className="p-5"> <div className="grid grid-cols-2"><h4 className="font-semibold">Unfulfilled Orders</h4></div>  <div className="flex justify-end"><Link to="/AllOrders">
            <div className="flex space-x-2 items-center hover:underline transition duration-500 ease-in-out">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
              <span className="font-semibold">Back to Orders</span>
            </div>
          </Link></div>
                    <hr className="border border-gray-200" />


          <div className="mt-3">
            <div className="grid grid-cols-2 uppercase text-blue-500">
            <div className="">
              <h5>Items</h5>
            </div>
            <div className="flex space-x-2 justify-around">
              <h5>Unit Price</h5>
              <h5>Quantity</h5>
              <h5>Total</h5>
            </div>
          </div>
          
          {/* All Orders */}

          <div>    <div className="shadow-md my-2 border-gray-200 border-2 p-3 bg-white rounded-lg grid grid-cols-2">
            <div className="flex space-x-2 items-center">
              <div className="img">
                <img
                  src="https://images.heb.com/is/image/HEBGrocery/001285816"
                  alt="order_img"
                  className="w-32"
                />
              </div>
              <div className="flex flex-col">
                <h5 className="text-blue-500">Dettol Soap</h5>{" "}
                <span>Antisceptic Dettol soap</span>
              </div>
            </div>
            <div className="flex items-center justify-around font-semibold">
              <p>&#8358;300</p>
              <p>5</p>
              <p>&#8358;1500</p>
            </div>
          </div>
          {/* Order - 2 */}
          <div className="shadow-md my-2 border-gray-200 border-2 p-3 bg-white rounded-lg grid grid-cols-2">
            <div className="flex space-x-2 items-center">
              <div className="img">
                <img
                  src="https://images.heb.com/is/image/HEBGrocery/001285816"
                  alt="order_img"
                  className="w-32"
                />
              </div>
              <div className="flex flex-col">
                <h5 className="text-blue-500">Dettol Soap</h5>{" "}
                <span>Antisceptic Dettol soap</span>
              </div>
            </div>
            <div className="flex items-center justify-around font-semibold">
              <p>&#8358;300</p>
              <p>5</p>
              <p>&#8358;1500</p>
            </div>
          </div>
          {/* Order -3  */}
          <div className="shadow-md my-2 border-gray-200 border-2 p-3 bg-white rounded-lg grid grid-cols-2">
            <div className="flex space-x-2 items-center">
              <div className="img">
                <img
                  src="https://images.heb.com/is/image/HEBGrocery/001285816"
                  alt="order_img"
                  className="w-32"
                />
              </div>
              <div className="flex flex-col">
                <h5 className="text-blue-500">Dettol Soap</h5>{" "}
                <span>Antisceptic Dettol soap</span>
              </div>
            </div>
            <div className="flex items-center justify-around font-semibold">
              <p>&#8358;300</p>
              <p>5</p>
              <p>&#8358;1500</p>
            </div>
          </div>
          
          {/* Order Endings */}
           <hr className="border border-gray-200" />
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <h5>
                Order No <span className="text-blue-500">3457GGHBDH3</span>
              </h5>
              <span className="font-semibold">3 item(s)</span>
              <span className="font-semibold">
                placed on <span className="text-blue-500">21-03-2020</span>
              </span>
               <div className="flex space-x-2"><span className="font-semibold">Offline | Online</span> - <span className="text-blue-500 font-semibold">Offline</span></div>
              <div className="flex space-x-2"><span className="font-semibold">Store Bought</span> - <span className="text-blue-500">Ajah Branch</span></div>
              <div className="flex space-x-2"><span className="font-semibold">Delivery Method</span> - <span className="text-blue-500">Pick Up</span></div>
              <div className="flex space-x-2"><span className="font-semibold">Payment Method</span> - <span className="text-blue-500">Cash On Delivery</span></div>
              <div className="flex space-x-2"><span className="font-semibold">Customer Name</span> - <span className="text-blue-500">Adeola Odeku</span></div>
              <div className="flex space-x-2"><span className="font-semibold">Reference Number</span> - <span className="text-blue-500">GGHDBBB3477367</span></div>
              <div className="flex space-x-2"><span className="font-semibold">Transaction Reference</span> - <span className="text-blue-500">GGHDBBB3477367</span></div>
              <span className="font-semibold">
                Total: <span className="text-blue-500">&#8358;4000</span>
              </span>
            </div>
            <div className="flex space-x-3 justify-end items-center">
              <div className="bg-red-300 text-red-800 font-semibold rounded-lg px-2 py-1">
                UnFulfilled Order
              </div>
              <div className="border-2 border-blue-500 hover:bg-blue-500 transition hover:text-white duration-500 ease-in-out text-blue-500 font-semibold rounded-lg px-2 py-1 cursor-pointer">
                Fulfill Order
              </div>
            </div>
          </div>
          
          </div>
          
          </div>
          
          </Paper></div>
  )
}

export default UnfulfilledOrders